import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { DemoTranslatorFormats, DemoTranslatorWorkflow } from "@/features/training/components/demo"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function TranslatorIntroductionPage() {
  const { t } = useTranslation("", { keyPrefix: "training.ai-translator.introduction" })

  const featuresList = ensureArray<string>(t("key_features_list", { returnObjects: true }))

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("main_title")}</h2>
        <p>{t("description")}</p>
      </CourseSection>

      <CourseSection>
        <h3>{t("workflow_title")}</h3>
        <p>{t("workflow_intro")}</p>
        <div className="my-2">
          <DemoTranslatorWorkflow />
        </div>
      </CourseSection>

      <CourseSection>
        <h3>{t("formats_title")}</h3>
        <p>{t("formats_intro")}</p>
        <div className="my-2">
          <DemoTranslatorFormats />
        </div>
      </CourseSection>

      <CourseSection>
        <h3>{t("key_features")}</h3>
        <CourseList data={featuresList} />
      </CourseSection>
    </CourseLayout>
  )
}
